
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summit/thanks",
      function () {
        return require("private-next-pages/summit/thanks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summit/thanks"])
      });
    }
  